export const formatDateToISOWithLocalTimezone = (date: Date) => {
  const offset = date.getTimezoneOffset() * 60000;
  const localISOTime = new Date(date.getTime() - offset)
    .toISOString()
    .slice(0, -1);
  return localISOTime;
};
